import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.nivelPrioridad.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.nivelPrioridad.fields.nombre'),
  },
  {
    name: 'nivel',
    label: i18n('entities.nivelPrioridad.fields.nivel'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.nivelPrioridad.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.nivelPrioridad.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
